import { render, staticRenderFns } from "./onebox-mypackage.vue?vue&type=template&id=5422e42a&"
import script from "./onebox-mypackage.vue?vue&type=script&lang=js&"
export * from "./onebox-mypackage.vue?vue&type=script&lang=js&"
import style0 from "./onebox-mypackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports